<template>
  <div class="settlement-container">
    <div v-if="!loading">
      <div class="top-tip">
        <div class="top-tip-content">
          <van-icon
            name="info-o"
            class="icon-tips"
          /> {{ banks.length === 0 ? TIPS1 : TIPS2 }}
        </div>
      </div>
      <mtd-form
        v-show="!banks.length"
        ref="form"
        :rules="ruleCustom"
        :model="formCustom"
      >
        <mtd-form-item
          :label-width="60"
          label="手机号"
          prop="phone"
        >
          {{ formCustom.phone }}
        </mtd-form-item>
        <mtd-form-item
          :label-width="60"
          label="验证码"
          prop="verificationCode"
        >
          <div class="display-center">
            <mtd-input
              v-model="formCustom.verificationCode"
              class="input-code"
              placeholder="请输入验证码"
              type="number"
            />
            <mtd-button
              type="primary"
              :disabled="sending || isSend"
              @click="handleSendCode"
            >
              {{ btnText }}
            </mtd-button>
          </div>
        </mtd-form-item>
      </mtd-form>
      <mtd-table
        v-show="banks.length"
        :data="banks"
        size="small"
      >
        <mtd-table-column
          width="90"
          prop="name"
          label="账户名"
        />
        <mtd-table-column
          prop="bankNumber"
          label="银行卡号"
        >
          <template slot-scope="scope">
            <div class="bank-number">
              {{ scope.row.bankNumber }}
              <mtd-button
                type="text-primary"
                size="small"
                @click="openModal(scope.row.bankAccountId)"
              >
                查看银行卡
              </mtd-button>
            </div>
          </template>
        </mtd-table-column>
      </mtd-table>
      <div
        v-show="banks.length"
        class="load-more"
      >
        <mtd-button
          v-if="hasMore"
          type="text-primary"
          @click="showMore"
        >
          点击加载更多
        </mtd-button>
        <div
          v-else
          class="no-more"
        >
          没有数据了...
        </div>
      </div>
      <div class="bottom-btn">
        <mtd-button
          v-if="!isBound"
          class="btn-confirm"
          type="primary"
          :loading="submitting"
          :disabled="!(formCustom.verificationCode && formCustom.verificationCode.length === 6)"
          @click="submit('formCustom')"
        >
          {{ banks.length ? '确认绑定':'确认' }}
        </mtd-button>
        <mtd-button
          v-else
          ghost
          type="primary"
        >
          绑定成功
        </mtd-button>
      </div>
      <mtd-modal
        v-model="visible"
        class="bank-modal"
        :closable="false"
      >
        <div>
          <div
            slot="title"
            class="bank-modal-title"
          >
            银行卡信息
          </div>
          <div>{{ bankNumber }}</div>
          <div
            slot="footer"
            class="bank-modal-footer"
          >
            <mtd-button
              ghost
              type="primary"
              @click="closeModal"
            >
              确认
            </mtd-button>
          </div>
        </div>
      </mtd-modal>
    </div>
    <mtd-loading v-else />
  </div>
</template>

<script>
import SettlementApi from '@/api/settlement';
import STATUS from '@/constants/status';

const TIPS1 = '为了保证您的信息安全，需要通过手机校验';
const TIPS2 = '请确认银行卡信息无误后，点击确认绑定！';
const SEND_CODE_TEXT = '发送验证码';
const pageSize = 100;
export default {
  name: 'Settlement',
  data() {
    return {
      customerId: '',
      TIPS1,
      TIPS2,
      banks: [],
      list: [],
      hasMore: false,
      pageNum: 1,
      submitting: false,
      loading: true,
      sending: false,
      isBound: false,
      formCustom: {
        phone: '',
        verificationCode: '',
      },
      ruleCustom: {
        verificationCode: (rule, value, callback) => {
          if (value.length > 6) {
            callback(new Error('不能超过6个字符'));
          }
          callback();
        },

      },
      btnText: SEND_CODE_TEXT,
      codeError: false,
      visible: false,
      bankNumber: '',
    };
  },
  computed: {
    isSend() {
      return this.btnText !== SEND_CODE_TEXT;
    },
  },
  created() {
    const { customerId } = this.$route.query;
    this.customerId = customerId;
    this.getPhoneNumber();
  },
  methods: {
    async openModal(bankAccountId) {
      const { data: { bankNumber } } = await SettlementApi.getBankCardNumber(this.customerId, bankAccountId);
      this.bankNumber = bankNumber;
      this.visible = true;
    },
    closeModal() {
      this.visible = false;
    },
    async submit() {
      this.submitting = true;
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const { verificationCode } = this.formCustom;
          const bankAccountId = this.banks.map(((bank) => bank.bankAccountId));
          let api = SettlementApi.getBankAccount;
          if (this.banks.length) {
            api = SettlementApi.confirmBank;
          }
          try {
            const { respCode, respMsg, data } = await api(this.customerId, verificationCode, bankAccountId);
            if (respCode === STATUS.SUCCESS) {
              if (data.banks) {
                this.banks = data.banks;
                // 1未绑定，2已绑定
                this.isBound = data.bound === 2;
              } else {
                this.isBound = true;
                this.$dialog.toast('绑定成功');
              }
            } else {
              this.$dialog.toast(respMsg || '操作失败');
            }
            this.submitting = false;
          } catch (e) {
            this.submitting = false;
            this.$dialog.toast(e.respMsg || '操作失败');
          }
        } else {
          this.submitting = false;
        }
      });
    },
    async getPhoneNumber() {
      const { data } = await SettlementApi.getPhoneNumber(this.customerId);
      this.formCustom.phone = data && data.phone;
      this.loading = false;
    },
    async getBankInfo() {
      const { respCode, respMsg, data } = await SettlementApi.getBankAccount(this.customerId);
      if (respCode === STATUS.SUCCESS) {
        if (data.banks) {
          this.list = data.banks;
          if (data.banks.length <= pageSize) {
            this.banks = data.banks;
            this.hasMore = false;
          } else {
            this.banks = data.banks.slice(0, pageSize);
            this.hasMore = true;
          }
        } else {
          this.$dialog.toast(respMsg || '获取失败');
        }
      }
    },
    showMore() {
      this.banks = [...this.banks, ...this.list.slice(this.pageNum * pageSize, (this.pageNum + 1) * pageSize)];
      this.pageNum += 1;
      if (this.list.length >= this.pageNum * pageSize) {
        this.hasMore = true;
      } else {
        this.hasMore = false;
      }
    },
    async handleSendCode() {
      this.sending = true;
      let second = 60;
      const tick = () => {
        this.btnText = `${second}秒后可重新获取`;
        this.sending = false;
        second -= 1;
        if (second < 0) {
          clearInterval(this.countDown);
          this.btnText = SEND_CODE_TEXT;
        } else {
          this.countDown = setTimeout(tick, 1000);
        }
      };
      this.countDown = setTimeout(tick, 1000);
      await SettlementApi.sendMsgCode(this.customerId);
    },
  },
};
</script>

<style lang="scss" scoped>
.settlement-container {
  background: #fff;
  min-height: 100vh;
  text-align: left;
  padding: 30px;
  .top-tip {
    background: #FFF;
    margin-bottom: 18px;
    .top-tip-content {
      background: #FFFAE0;
      color: #C28100;
      height: 76px;
      display: flex;
      align-items: center;
      padding: 0 10px;
      border-radius: 12px;
      font-size: 26px;
      b {
        font-weight: bold;
      }
    }
    .icon-tips {
      &::before{
        color: #F5BA31;
        font-size: 32px;
        padding-right: 10px;
      }
    }
  }
  .input-code {
    width: 240px;
    margin-right: 20px;
  }
  .display-center {
    display: flex;
    align-items: center;
  }
  .bottom-btn {
    text-align: center;
    margin-top: 200px;
  }
  .btn-confirm {
    width: 216px;
  }
  .bank-number {
    display: flex;
    justify-content: space-between;
  }
  .load-more {
    text-align: center;
    padding: 40px 0;
    .no-more {
      color: #adadad;
    }
  }
}

.bank-modal {
  text-align: center;
}
/deep/.mtd-modal {
  min-width: 600px;
}
.bank-modal-title {
  font-size: 36px;
  margin-bottom: 50px;
  font-weight: bold;
  color: #333;
}
.bank-modal-footer {
  display: flex;
  justify-content: center;
  margin-top: 50px;
}
</style>
